import script from "./goods-status.vue?vue&type=script&setup=true&lang=js"
export * from "./goods-status.vue?vue&type=script&setup=true&lang=js"

import "./goods-status.vue?vue&type=style&index=0&id=5b64a960&scoped=true&lang=css"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b64a960"]])

export default __exports__